import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class DailySubdirectorPolicy extends BasePolicy {
  static canView() {
    const roles = [
      Roles.DIRECTOR,
      Roles.SUB_DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUPER_USER,
      Roles.POST_SALE,
      Roles.MARKETING,
    ];

    const channels = [Channels.WHOLESALER, Channels.RETAIL];
    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
